/*
 * File: CustomerSelectionStep.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 17 May 2021 1:40:29 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Col, Row, Space, Typography } from 'antd';
import { RefetchButtonCustomers } from 'components/atoms/RefetchButtonCustomers';
import { CustomerIdFilter } from 'components/atoms/customerSelectionFilters/CustomerIdFilter';
import { CustomerNameFilter } from 'components/atoms/customerSelectionFilters/CustomerNameFilter';
import { CustomerSelectionGrid } from 'components/molecules/CustomerSelectionGrid';
import { InlineStylesModel } from 'models/InlineStylesModel';

const styles: InlineStylesModel = {
  searchRow: {
    height: 60,
    padding: '0px 20px',
    backgroundColor: '#b0b2bc'
  },
  searchTitle: {
    marginBottom: 0,
    color: 'black'
  },
  resultsTitleRow: {
    margin: '10px 0px'
  },
  gridRow: {
    height: 'calc(100vh - 378px )',
    marginTop: 10,
    padding: '10px 0px'
  }
};

export const CustomerSelectionStep = (): JSX.Element => {
  /* ****************** Render ****************** */
  return (
    <>
      <Row style={styles.searchRow} align="middle" justify="space-between">
        <Col>
        <Space>
          <Typography.Title level={4} style={styles.searchTitle}>
            Search Customers
          </Typography.Title>
          <RefetchButtonCustomers />
          </Space>
        </Col>
        <Col>
          <Space>
            <Typography.Text style={{ color: 'black' }}>Search Filters</Typography.Text>
            <CustomerIdFilter />
            <CustomerNameFilter />
          </Space>
        </Col>
      </Row>
      <Row>
        <CustomerSelectionGrid />
      </Row>
    </>
  );
};
